import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Category from '../../types/category.type';
import { fetchCategories, localCategories } from '../../services/products/all-category.service';

interface CategoryState {
    items: Category[];
    loading: boolean;
    error: string | null;
    fetched: boolean;
}

const initialLocalItems = localCategories();

const initialState: CategoryState = {
    items: initialLocalItems,
    loading: false,
    error: null,
    fetched: false,
};

export const loadCategories = createAsyncThunk(
    'categories/loadCategories',
    async () => {
        const categories = await fetchCategories();
        return categories;
    }
);

const categorySlice = createSlice({
    name: 'categories',
    initialState,
    reducers: {
        clearCategories: (state) => {
            state.items = [];
            state.fetched = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(loadCategories.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(loadCategories.fulfilled, (state, action) => {
                state.loading = false;
                if (action.payload && action.payload.length > 0) {
                    state.items = action.payload;
                }
                state.fetched = true;
            })
            .addCase(loadCategories.rejected, (state, action) => {
                state.loading = false;
                state.fetched = true;
                state.error = action.error.message || 'Failed to fetch categories';
            });
    },
});

export const { clearCategories } = categorySlice.actions;
export default categorySlice.reducer;
